import React, { useState } from 'react';
import { Field } from 'web/components/Field';
import { useForm } from 'react-hook-form';
import { PrimaryButton } from 'web/components/PrimaryButton';
import { ForgotForm, useForgotPassword } from 'web/services/api/queries';
import { Card } from 'web/components/Card';

const ForgotPage = () => {
    const { mutate: forgotPassword, data: isResetLinkSend, isLoading: isForgotPasswordLoading, error: forgotPasswordError } = useForgotPassword();
    const { register, handleSubmit, formState: { errors, isSubmitted } } = useForm<ForgotForm>();
    const [lastData, setLastData] = useState<ForgotForm | null>(null);

    const onSubmit = (data: ForgotForm) => {
        forgotPassword(data);
        setLastData(data);
    };

    const resend = () => {
        if (!lastData) return;
        forgotPassword(lastData);
    }

    if (isResetLinkSend) {
        return (
            <Card>
                <div className="flex flex-col font-semibold">
                    <p className='text-[#1C1C1C] pb-4'>We've sent you an email with a link to reset your password. Please check your inbox (and spam folder) for an email from us.</p>
                    <p className='text-[#3A3A3A]'>Didn't receive an email? <a className="text-[#26818E] cursor-pointer underline" onClick={resend}>Try again</a></p>
                </div>
            </Card>
        )
    }

    return (
        <Card>
            <Card.Header title="Forgot Password" />
            <form onSubmit={handleSubmit(onSubmit)} className='flex flex-col gap-5'>
                <Field
                    label="Email"
                    required
                    showTips={isSubmitted}
                    error={errors.email?.message}
                    tips={{
                        placeholder: "E.g.. john.doe@example.com",
                    }}
                    inputProps={{
                        autoComplete: "email",
                        ...register('email', {
                            required: true,
                            pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                message: "Invalid email address",
                            },
                        }),
                        type: "email",
                    }}
                />
                {forgotPasswordError && <p className="text-red-500">{forgotPasswordError}</p>}
                <div className="flex flex-col md:flex-row md:gap-0 gap-2 items-center justify-between w-full">
                    <PrimaryButton type="submit" disabled={isForgotPasswordLoading}>Send reset link</PrimaryButton>
                    <p className="w-1/2 flex items-center justify-center">
                        <a className="text-[#26818E] relative font-semibold underline" href='/login'>Return to login</a>
                    </p>
                </div>
            </form>
        </Card>
    )
};

export default ForgotPage;
